import React from 'react';

const BusinessLoanChart = () => {
    const salariedRates = [
    { type: 'Business Loan', rate: '13%*', bank: 'IndusInd Bank' },
    { type: 'Business Loan', rate: '15%*', bank: 'Standard Chartered Bank' },
    { type: 'Business Loan', rate: '16%*', bank: 'Deutsche Bank' },
    { type: 'Business Loan', rate: '15%*', bank: 'poonawala fincorp' },
    { type: 'Business Loan', rate: '13%*', bank: 'DBS Bank' },
    { type: 'Business Loan', rate: '10.75%*', bank: 'Axis Bank' },
    { type: 'Business Loan', rate: '10.75%', bank: 'HDFC Bank' },
   
  ];

  const selfEmployedRates = [
    { type: 'Business Loan', rate: '13%*', bank: 'IndusInd Bank' },
    { type: 'Business Loan', rate: '15%*', bank: 'Standard Chartered Bank' },
    { type: 'Business Loan', rate: '16%*', bank: 'Deutsche Bank' },
    { type: 'Business Loan', rate: '15%*', bank: 'poonawala fincorp' },
    { type: 'Business Loan', rate: '13%*', bank: 'DBS Bank' },
    { type: 'Business Loan', rate: '10.75%*', bank: 'Axis Bank' },
    { type: 'Business Loan', rate: '10.75%', bank: 'HDFC Bank' },
  ];

  return (
    <div className="container py-5">
      {/* Hero Section */}
      <div
        className="card text-white mb-5 shadow-lg"
        style={{ background: 'linear-gradient(135deg, #1560bd, #1034a6)' }}
      >
        <div className="card-body p-5">
          <h1 className="display-4 fw-bold text-white" style={{ textShadow: '0 0 10px rgba(0, 0, 0, 0.689)' }}>
            <i className="bi bi-house-heart"></i> Business Loan Interest Rates
          </h1>
          <p className="lead">Starting from 10.75%* p.a. for salaried individuals</p>
          <div className="alert alert-light mt-4">
            <i className="bi bi-info-circle"></i> Rates subject to change based on eligibility and market conditions
          </div>
        </div>
      </div>

      {/* Interest Rates Tables */}
      <div className="row g-4">
        <div className="col-md-6">
          <RateCard title="Salaried Applicants" color="#1034a6" data={salariedRates} />
        </div>
        <div className="col-md-6">
          <RateCard title="Self-Employed Applicants" color="#0072ff" data={selfEmployedRates} />
        </div>
      </div>

      {/* Other sections remain unchanged... */}
    </div>
  );
};

const RateCard = ({ title, color, data }) => (
  <div className="card h-100 shadow">
    <div
      className="card-header bg-primary text-white"
      style={{ background: `linear-gradient(135deg, #1560bd, ${color})` }}
    >
      <h3 className="mb-0 text-white">
        <i className={`bi ${title.includes('Salaried') ? 'bi-briefcase' : 'bi-person-workspace'} text-white`} style={{ textShadow: '0 0 10px rgba(0, 0, 0, 0.689)' }}></i> {title}
      </h3>
    </div>
    <div className="card-body">
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead className="table-light">
            <tr>
              <th>Loan Type</th>
              <th>Interest Rate</th>
              <th>Bank Name</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>{row.type}</td>
                <td>{row.rate}</td>
                <td>{row.bank}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default BusinessLoanChart;
